const MAXIMUM_CAMPAIGN_COUNT_UNDER_ACCOUNT = 10000;

export const getCampaignOdataConfig = () => ({
  top: MAXIMUM_CAMPAIGN_COUNT_UNDER_ACCOUNT,
  select: ['Id', 'Name', 'Status', 'CampaignType', 'CampaignSubType', 'ExperimentId', 'ImportProperties'],
  orderby: { Name: 1 },
});
